import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
    return (
        <div className="home-container">
            <header className="home-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <div className="home-content">
                <p className="home-description">
                    I write about technology, programming, finance, mathematics, economics, any type of research, 
                    and my experiences in life. My essays are shaped by the things I've experienced, read, or 
                    explored - sometimes technical, sometimes personal, and often from whatever topic happens to 
                    catch my curiosity.
                </p>
                
                <div className="home-buttons">
                    <Link to="/blog" className="home-button">Essays</Link>
                    <Link to="/about" className="home-button">About Me</Link>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
